var map = {
	"./business-account/ukko-business-account-2-en.png": 75978,
	"./business-account/ukko-business-account-2-fi.png": 38624,
	"./business-account/ukko-business-account-en.png": 21043,
	"./business-account/ukko-business-account-fi.png": 9241,
	"./business-account/ukko-x-swan.png": 82297,
	"./features/desktop/debt_collection.png": 24640,
	"./features/desktop/foreign_sales.png": 74657,
	"./features/desktop/payment_account.png": 32424,
	"./features/desktop/ukko_assurance.png": 97036,
	"./features/desktop/ukko_checkout.png": 31093,
	"./features/desktop/ukko_plus.png": 7705,
	"./features/dialogs/debt_collection.png": 30461,
	"./features/dialogs/foreign_sales.png": 90504,
	"./features/dialogs/ukko_assurance.png": 56039,
	"./features/dialogs/ukko_checkout.png": 58344,
	"./features/dialogs/ukko_plus.png": 42756,
	"./features/mobile/debt_collection.png": 7922,
	"./features/mobile/foreign_sales.png": 86839,
	"./features/mobile/payment_account.png": 72918,
	"./features/mobile/ukko_assurance.png": 50074,
	"./features/mobile/ukko_checkout.png": 73219,
	"./features/mobile/ukko_plus.png": 31155,
	"./features/ukko_plus.svg": 5672,
	"./features/ukko_plus_team.png": 74564,
	"./logos/if.png": 28687,
	"./logos/kravia_white.svg": 48224,
	"./logos/sumup_white.svg": 54990,
	"./logos/suomalaistapavelua.png": 42125,
	"./logos/suomen-vahvimmat.png": 26619,
	"./oy/login-screen.jpg": 96236,
	"./oy/logo_en.svg": 64199,
	"./oy/logo_fi.svg": 83329,
	"./oy/logo_plain.svg": 22796,
	"./payment-terminals/izettle.svg": 85117,
	"./payment-terminals/sumup.svg": 69826,
	"./payment-terminals/sumup_info.png": 85681,
	"./spotlight/business_account-spotlight-en.png": 2143,
	"./spotlight/business_account-spotlight-fi.png": 37101,
	"./spotlight/oy-spotlight-en.png": 52621,
	"./spotlight/oy-spotlight-fi.png": 47547,
	"./spotlight/tlp-spotlight-en.png": 30611,
	"./spotlight/tlp-spotlight-fi.png": 14489,
	"./spotlight/ukkopro-spotlight-en.png": 58876,
	"./spotlight/ukkopro-spotlight-fi.png": 8762,
	"./tlp/briefcase.svg": 49738,
	"./tlp/login-screen.jpg": 69768,
	"./tlp/logo_en.svg": 87805,
	"./tlp/logo_fi.svg": 20055,
	"./tlp/logo_plain.svg": 32582,
	"./tlp/stamp.svg": 30001,
	"./ukkopro/login-screen.jpg": 74867,
	"./ukkopro/logo_en.svg": 87008,
	"./ukkopro/logo_fi.svg": 46954,
	"./ukkopro/logo_plain.svg": 6937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79828;